import { Divider, FormControlLabel, Switch } from "@mui/material";
import { DeferredSearchField } from "design-components";

export interface OperatorDetailCustomersToolbarProps {
  searchValue: string;
  onSearchTrigger: (value: string) => void;
  onFilterClick: () => void;
  showOnlyActive: boolean;
  onShowOnlyActiveChange: (value: boolean) => void;
}

export function OperatorDetailCustomersToolbar(props: OperatorDetailCustomersToolbarProps) {
  const { searchValue, onSearchTrigger, onFilterClick, showOnlyActive, onShowOnlyActiveChange } = props;

  return (
    <div className="users-toolbar operator-detail-customers-toolbar">
      <div className="users-toolbar__actions" aria-hidden />
      <div className="users-toolbar__admin-secondary-wrap">
        <FormControlLabel
          className="users-toolbar__toggle-label users-toolbar__toggle-label--aviro-active"
          control={
            <Switch
              checked={showOnlyActive}
              onChange={(_, checked) => onShowOnlyActiveChange(checked)}
              inputProps={{ "aria-label": "Show only active customers" }}
              className="toggle"
            />
          }
          label="Show only active"
        />
        <div className="users-toolbar__divider-wrap">
          <Divider orientation="vertical" flexItem className="users-toolbar__divider" />
        </div>
      </div>
      <div className="users-toolbar__search-wrap operators-toolbar__search-wrap">
        <DeferredSearchField
          className="users-toolbar__search-field"
          placeholder="Search..."
          searchValue={searchValue}
          onSearchTrigger={onSearchTrigger}
          onFilterClick={onFilterClick}
          fullWidth
          size="small"
        />
      </div>
    </div>
  );
}
